import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { DECIMAL, PERCENT } from "const"
import {
    StoreType,
    ChangeUserSettings,
    updateUserSettings,
} from "client/store"
import {
    FormGroup,
    Label,
    RadioButton,
    IncreaseInput,
    CheckboxWrapper,
} from "client/components"

import DecimalExample from "./decimalExample"


const Percentage = () => {
    const settings = useSelector((state: StoreType) => state.userSettings.settings.sil)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const onChange = (value: ChangeUserSettings) => {
        dispatch(updateUserSettings("sil", value))
    }

    const {
        percentage,
        percentageDecimal,
    } = settings

    return (
        <Row>
            <Col xs={4}>
                <FormGroup>
                    <Label>{lang.percentageFields}</Label>
                    <CheckboxWrapper displayColumn>
                        <RadioButton
                            checked={percentage === DECIMAL}
                            onChange={() => onChange({ percentage: DECIMAL })}
                            title="0-1"
                        />
                        <RadioButton
                            checked={percentage === PERCENT}
                            onChange={() => onChange({ percentage: PERCENT })}
                            title="0-100 %"
                        />
                    </CheckboxWrapper>
                </FormGroup>
            </Col>
            <Col xs={8}>
                <FormGroup>
                    <Label>{lang.decimal}</Label>
                    <Row>
                        <Col xs={6}>
                            <IncreaseInput
                                onChange={(val) => onChange({ percentageDecimal: val })}
                                value={percentageDecimal}
                            />
                        </Col>
                        <Col xs={6}>
                            <DecimalExample format={percentage} decimal={percentageDecimal} />
                        </Col>
                    </Row>
                </FormGroup>
            </Col>
        </Row>
    )
}
export default Percentage
